import '../Style/menu.css'
import '../Style/hamburger.css'

const Menu = () => {

	return (
		<div id="Menu" className="row-container">

		 	<div className="media-icons row-container">

		 		<a href="#" target="_blank"><i className="whatsapp icon large"></i></a>
		 		<a href="https://instagram.com/a_.thousand._words?igshid=fg95yjd0jra8" target="_blank"><i className="instagram icon large"></i></a>
		 		<a href="#" target="_blank"><i className="share alternate icon large"></i></a>

		 	</div>

		 	<div className="spacer"></div>

		    <div className="hamburger">

		    	<div className="hamburger-wrapper">
			    	<input type="checkbox" className="toggler"/>
		    		<i className="bars icon large"></i>
				 	<nav className="menu">
				 		<div>
				 			<i className="arrow alternate circle up icon large"></i>
				 		</div>

						 	<ul>
						 		<a href="#Portfolio"><li>Portfolio</li></a>
						 		<a href="#Contact"><li>Contact</li></a>
						 		<a href="#About"><li> About</li></a>
						 	</ul>
				 	</nav>
		    	</div>
		    	
		    	{/*<i className="bars icon large"></i>*/}

		    </div>

		</div>
	)

}

export default Menu;